export const tags = [
    'ClinicalTrialSponsorName',
    'ClinicalTrialSiteID',
    'ClinicalTrialSiteName',
    'ClinicalTrialSubjectID',
];
